import Cookies from '../../vendor/js.cookie.min.mjs';
import {
  rightStore,
  intSubdomain,
  getUrlRedirect,
  getQueryString,
  getDataLocations,
  getCountry,
  getUrl,
} from '../../utils/geo';

// variables for geo selector
const geoDataEl = document.querySelectorAll<HTMLElement>('[data-selector-geo]');
const currentSelector = document.querySelectorAll<HTMLElement>(
  '[data-geo-selector-current]'
);
const geoSelectorIconEl = document.querySelectorAll<HTMLElement>(
  '[data-geo-selector-icon]'
);
const geoSelector = document.querySelector<HTMLElement>(
  '.geo-selector.desktop'
);
const geoSelectorValue = document.querySelectorAll<HTMLElement>(
  '[data-geo-selector-value]'
);
const selectorItem = document.querySelectorAll<HTMLElement>(
  '[data-geo-selector-url]'
);
const currentUrl = window.location.href.split('/')[2];
const protocol = 'https://';

// variables for geo selector in modal
const modal = document.querySelector<HTMLElement>('[data-geo-modal]');
const countryEl = document.querySelectorAll<HTMLElement>(
  '.replace-geo-country'
);
const zoneEl = document.querySelectorAll<HTMLElement>('.replace-geo-zone');
const intOption = document.querySelector<HTMLFormElement>(
  'option#International'
);
const geoCloseModalEls =
  document.querySelectorAll<HTMLElement>('[data-close-modal]');
const intDomain = 'int.roseskinco.com';
const haveStore = document.querySelector<HTMLElement>('[data-have-store]');
const notHaveStore = document.querySelector<HTMLElement>(
  '[data-nothave-store]'
);
const geoSelectorModalEl = document.querySelector<HTMLInputElement>(
  '[data-modal-selector-geo]'
);
const paths = getUrl();

const setRedirectOrModal = async (): Promise<void> => {
  const isInternational: boolean = intSubdomain();
  const isRightStore: boolean = await rightStore();
  const urlStore: string | boolean = await getUrlRedirect();
  const queryString: string | undefined = getQueryString();
  const isThereBetterDomain: boolean = urlStore !== false;
  const hasCookie = Boolean(Cookies.get('geoModal'));

  const url = `${protocol}${urlStore}${paths}${
    queryString ? `?${queryString}` : ''
  }`;

  if (isInternational && !isRightStore && isThereBetterDomain && !hasCookie) {
    setTimeout(() => {
      window.location.href = url;
    }, 500);
  }

  if (window.Shop === 'usa') {
    if (!isInternational && !isRightStore && !hasCookie) {
      setGeoModal();
    }
  } else {
    if (!isRightStore && !hasCookie) {
      setGeoModal();
    }
  }

  const clearEl: HTMLElement | null = document.querySelector<HTMLElement>(
    '.c-hero-split__title'
  );
  clearEl?.addEventListener('click', function (): void {
    Cookies.remove('geoModal');
  });
};

const setGeoSelector = (): void => {
  const queryString: string = getQueryString();

  selectorItem.forEach((el: HTMLElement) => {
    el.addEventListener('click', function (evt: Event) {
      evt.preventDefault();
      const value: string | null = el.getAttribute('data-geo-selector-url');
      Cookies.set('geoModal', true, { expires: 1 });
      const fullUrl = `${protocol}${value}${paths}${
        queryString ? `?${queryString}` : ''
      }`;
      setTimeout(() => {
        if (window.Shop === 'usa') {
          window.location.href = fullUrl;
        } else {
          const country = el.getAttribute('id');
          updateLocation(country, fullUrl);
        }
      }, 500);
    });
  });

  geoSelectorValue.forEach((el: HTMLElement) => {
    const value: string | null = el.getAttribute('data-geo-selector-value');
    if (value === currentUrl) {
      const htmlItem: string = el.innerHTML;
      currentSelector.forEach((el: HTMLElement) => {
        el.innerHTML = htmlItem;
      });
    } else if (window.Shop === 'usa') {
      // Sets initial geo selector for dev themes to enable geo selector functionality
      const htmlItem: string = `<a href="#" data-geo-selector-url="roseskinco.com" id="United States" class="active">
                                  <img loading="lazy" src="https://cdn.accentuate.io/55887855731/1689857772468/CountryIcons-01.svg?v=1689857772468" width="16" height="16" alt="">
                                  <span>United States</span>
                                </a>`;
      currentSelector.forEach((el: HTMLElement) => {
        el.innerHTML = htmlItem;
      });
    }
  });

  currentSelector?.forEach((el: HTMLElement) => {
    el.addEventListener('click', function (evt: Event) {
      evt.preventDefault();
      geoDataEl.forEach((el: HTMLElement) => {
        el.classList.toggle('is-active');
      });
      geoSelectorIconEl.forEach((el: HTMLElement) => {
        el.classList.toggle('is-active');
      });
    });
  });

  if (window.innerWidth > 768) {
    document.addEventListener('click', function (evt: Event) {
      const target: HTMLElement = evt.target as HTMLElement;
      const isClickInside: boolean | undefined = geoSelector?.contains(target);
      if (!isClickInside) {
        geoDataEl?.forEach((el: HTMLElement) => {
          el.classList.remove('is-active');
        });
      }
    });
  }
};

const setGeoModal = async (): Promise<void> => {
  const geoDataList = await getDataLocations();
  const country = await getCountry();
  const queryString = getQueryString();
  const ifInCountries = Object.keys(geoDataList).find((zone) =>
    geoDataList[zone].countries.includes(country)
  );
  const currentDomain = Object.keys(geoDataList).find((zone) =>
    geoDataList[zone].domain.includes(currentUrl)
  );
  const currentZone = Object.keys(geoDataList).find((zone) =>
    geoDataList[zone].countries.includes(country)
  );
  const checkZone = currentZone === undefined ? 'International' : currentZone;
  let defaultUrl = '';

  countryEl?.forEach((el) => (el.innerHTML = country));
  zoneEl?.forEach((el) => (el.innerHTML = checkZone));

  if (ifInCountries) {
    haveStore?.classList.remove('option-is-hidden');
  } else {
    notHaveStore?.classList.remove('option-is-hidden');
  }

  geoCloseModalEls?.forEach((el) => {
    el.addEventListener('click', function () {
      Cookies.set('geoModal', true, { expires: 1 });
      setTimeout(() => {
        modal?.classList.remove('is-active');
      }, 500);
    });
  });

  if (currentDomain !== checkZone) {
    modal?.classList.add('is-active');
  }

  geoSelectorModalEl?.querySelectorAll('option').forEach((option: any) => {
    if (option.text === ifInCountries) {
      option.selected = true;
      defaultUrl = `${option.value}`;
    }
  });

  if (ifInCountries === undefined) {
    intOption?.setAttribute('selected', 'selected');
    defaultUrl = `${intDomain}`;
  }

  geoSelectorModalEl?.addEventListener('change', function () {
    const value = this.value;
    defaultUrl = `${value}`;
  });

  const goToStoreEl = document.querySelector<HTMLElement>(
    '[data-redirect-shop]'
  );

  goToStoreEl?.addEventListener('click', function () {
    const url = `${protocol}${defaultUrl}${paths}${
      queryString ? `?${queryString}` : ''
    }`;
    setTimeout(() => {
      if (window.Shop === 'usa') {
        window.location.href = url;
      } else {
        const countrySelect = document.querySelector<HTMLSelectElement>('[data-modal-selector-geo]');
        const selectedCountry = [...countrySelect.options].filter((option) => {
          return option.index === countrySelect.selectedIndex;
        })[0].innerText.trim();
        Cookies.set('geoModal', true, { expires: 1 });
        updateLocation(selectedCountry, url);
      }
    }, 500);
  });
};

function updateLocation(country, url) {
  const countryCodeForm = document.querySelector<HTMLFormElement>('[data-country-code-form]');
  const countryCodeSelect = document.querySelector<HTMLSelectElement>('[data-country-code-select]');

  if (!countryCodeForm || !country) { return; }

  if (country === 'United States') {
    window.location.href = url;
  } else {
    countryCodeSelect.value = [...countryCodeSelect.options].filter((option) => {
      return option.innerText.indexOf(country.toLowerCase()) >= 0;
    })[0].value;

    countryCodeForm.submit();
  }
}

setRedirectOrModal();
setGeoSelector();
